// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-page {
  max-width: 1200px;
  margin: 0 auto;
}

.upload-page h1 {
  margin-bottom: 30px;
  color: #333;
}

.upload-area {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 60px 20px;
  text-align: center;
  background: #fafafa;
  transition: all 0.3s;
  margin-bottom: 20px;
}

.upload-area.drag-active {
  border-color: #1976d2;
  background: #e3f2fd;
}

.upload-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.upload-area p {
  color: #666;
  margin-bottom: 20px;
}

.browse-button {
  background: #1976d2;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.3s;
}

.browse-button:hover:not(:disabled) {
  background: #1565c0;
}

.browse-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.uploading-text {
  color: #1976d2;
  margin-top: 10px;
  font-weight: 500;
}

.upload-note {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  font-style: italic;
}

.guidelines-section {
  background: white;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.guidelines-section h2 {
  margin-bottom: 15px;
  color: #333;
}

.guidelines-section ul {
  list-style-position: inside;
  color: #666;
  line-height: 1.8;
}

.guidelines-section li {
  margin-bottom: 10px;
}

.recent-uploads-section {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.uploads-table {
  width: 100%;
  border-collapse: collapse;
}

.uploads-table th {
  background: #f5f5f5;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #ddd;
}

.uploads-table td {
  padding: 12px;
  border-bottom: 1px solid #eee;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-processing {
  background: #cfe2ff;
  color: #084298;
}

.status-completed {
  background: #d1e7dd;
  color: #0f5132;
}

.status-submitted {
  background: #d1e7dd;
  color: #0f5132;
}

.status-error {
  background: #f8d7da;
  color: #842029;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-small {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-small.btn-primary {
  background: #1976d2;
  color: white;
}

.btn-small.btn-icon {
  background: transparent;
  font-size: 18px;
  padding: 4px 8px;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #666;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

/* Spinner animation for processing notification */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.spinner {
  display: inline-block;
}

/* Alert styles */
.alert-info {
  animation: fadeIn 0.3s ease-in;
}

.alert-success {
  animation: fadeIn 0.3s ease-in;
}

.alert-error {
  animation: fadeIn 0.3s ease-in;
}

.alert-warning {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Upload.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":[".upload-page {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.upload-page h1 {\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.upload-area {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 60px 20px;\n  text-align: center;\n  background: #fafafa;\n  transition: all 0.3s;\n  margin-bottom: 20px;\n}\n\n.upload-area.drag-active {\n  border-color: #1976d2;\n  background: #e3f2fd;\n}\n\n.upload-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n}\n\n.upload-area p {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.browse-button {\n  background: #1976d2;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background 0.3s;\n}\n\n.browse-button:hover:not(:disabled) {\n  background: #1565c0;\n}\n\n.browse-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.uploading-text {\n  color: #1976d2;\n  margin-top: 10px;\n  font-weight: 500;\n}\n\n.upload-note {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 30px;\n  font-style: italic;\n}\n\n.guidelines-section {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.guidelines-section h2 {\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.guidelines-section ul {\n  list-style-position: inside;\n  color: #666;\n  line-height: 1.8;\n}\n\n.guidelines-section li {\n  margin-bottom: 10px;\n}\n\n.recent-uploads-section {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.uploads-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.uploads-table th {\n  background: #f5f5f5;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #ddd;\n}\n\n.uploads-table td {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-processing {\n  background: #cfe2ff;\n  color: #084298;\n}\n\n.status-completed {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n.status-submitted {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n.status-error {\n  background: #f8d7da;\n  color: #842029;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-small {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn-small.btn-primary {\n  background: #1976d2;\n  color: white;\n}\n\n.btn-small.btn-icon {\n  background: transparent;\n  font-size: 18px;\n  padding: 4px 8px;\n}\n\n.no-data {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n/* Spinner animation for processing notification */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.spinner {\n  display: inline-block;\n}\n\n/* Alert styles */\n.alert-info {\n  animation: fadeIn 0.3s ease-in;\n}\n\n.alert-success {\n  animation: fadeIn 0.3s ease-in;\n}\n\n.alert-error {\n  animation: fadeIn 0.3s ease-in;\n}\n\n.alert-warning {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
